export default "__VITE_ASSET__83559487__"